<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import UploadFile from './UploadFile/index.vue'
	import ResultsDisplay from './ResultsDisplay/index.vue'
	import billdetails from './billdetails/index.vue'
	import uploadresults from './uploadresults/index.vue'
export default {
	
  name: 'oinv',
  components: {
	  UploadFile,ResultsDisplay,billdetails,uploadresults
  },
  data: function() {
    return {
		headlist: getdata().headlist,
		chooseindex: 0
    };
  },
  created() {
  },
  methods: {
	  forchooseindex(e){
	  	this.chooseindex=e
	  }
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
